import { useState, useEffect } from "react";

import MatchesModal from "./matchesModal";
import DraggableTable from "../../common/table/draggableTable";
import ExternalImage from "../../common/image/externalImage";
import logos from "../../../textMaps/logos";
import useWindowDimensions from "../../../utils/useWindowDimensions";
import { findCountryLogo } from "../../../utils/predictionsUtil";

const DroppableTeamArea = ({
  teams,
  groupName,
  groupHeader,
  description,
  onDrop,
  onReorder,
  isLocked,
  matches,
  highlight,
  compact,
}) => {
  const { isSuperSmall } = useWindowDimensions();
  const [matchesOpen, setMatchesOpen] = useState(false);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    let newColumns = [{ testid: "team_name", content: (t) => t.name }];
    if (!isSuperSmall) {
      newColumns.unshift({
        content: (t) => (
          <ExternalImage
            uri={logos[findCountryLogo(t.name)]}
            width={compact ? 18 : 30}
            height={compact ? 12 : 20}
          />
        ),
      });
    }
    setColumns(newColumns);
  }, [isSuperSmall, compact]);

  const raiseDrop = ({ draggedItem, droppedOn }) => {
    onDrop({
      type: "update",
      draggedTeam: draggedItem,
      droppedOn,
      groupName,
    });
  };
  const raiseReorder = (item, direction, position) => {
    onReorder({
      type: "reorder",
      selectedTeam: { item, position },
      direction,
      groupName,
    });
  };

  return (
    <div style={{ marginTop: compact ? 4 : 10 }}>
      <div
        className={`draggable-table-container${compact ? " compact" : ""}`}
      >
        <div className="group-picker-header">
          <span>{groupHeader}</span>
          {description && (
            <div className="group-picker-header-description">{description}</div>
          )}
        </div>
        <DraggableTable
          data={teams}
          columns={columns}
          onDrop={raiseDrop}
          onReorder={raiseReorder}
          type="team"
          isLocked={isLocked}
          highlight={highlight}
        />
      </div>
      <div style={{ height: 5 }} />
      {matches && (
        <>
          <div className="text-center">
            <button
              className="btn btn-sm btn-info"
              onClick={() => setMatchesOpen(true)}
            >
              See Matches
            </button>
          </div>
          <MatchesModal
            isOpen={matchesOpen}
            setIsOpen={setMatchesOpen}
            matches={matches}
            header={`Group ${groupName} Matches`}
          />
        </>
      )}
    </div>
  );
};

export default DroppableTeamArea;
